import { CapoPlugin } from "/var/www/releases/aartedainfluencia-20260802-201559/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];